import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUser } from '../../data-access';

interface IAuthState {
  access_token: string;
  refresh_token: string;
  user: IUser;
}

const INITIAL_STATE = {
  access_token: '',
  refresh_token: '',
  user: {},
};

export const authSlice = createSlice({
  name: 'auth',
  initialState: INITIAL_STATE,
  reducers: {
    setUserData: (state = INITIAL_STATE, action: PayloadAction<Partial<IAuthState>>) => ({
      ...state,
      ...action.payload
    }),
    resetAuthData: () => ({ ...INITIAL_STATE }),
  }
});

// this is for dispatch
export const storeAuthActions = authSlice.actions;

// this is for configureStore
const authReducer = authSlice.reducer;

export default authReducer;